import axios from 'axios';
import alert_mixin from '@/utils/mixins/alert_mixin';
import formatting_mixins from '@/utils/mixins/formatting_mixins';
import { 
  GET_ENQUIRY_RESPONSES,
  get_headers,
  get_project_id,
  get_token,
  GET_ENQUIRY_FORM_QUESTIONS,
  SUBMIT_ENQUIRY_FORM,

} from '@/utils/constants/constants.js';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import 'datatables.net';
import $ from 'jquery';
import AICampusFooter from '@/components/probaworkflows_base_components/AICampusFooter/AiFooter.vue';
import { validate_phone_number, validate_email } from '@/utils/validations/validate_inputs';

export default {
  name: 'Leads',
  mixins: [alert_mixin , formatting_mixins],
  components:{
    AICampusFooter,
  },
  data: () => ({ 
    token: get_token(),
    headers: get_headers(),
    project_id: get_project_id(),
    enquiry_form_id: '',
    selected_status: 'in-progress', 
    show_log_modal: false,
    selected_lead: null,
    lead_responses: [],
    status_cards: [
      { title: 'New Lead', color_class: 'orange-text', type: 'in-progress', icon: 'fa-regular fa-hourglass-half', count: 0 },
      { title: 'Qualified', color_class: 'green-text', type: 'submitted', icon: 'fa-solid fa-check-double', count: 0 },
      { title: 'Negotiation', color_class: 'text-danger', type: 'awaiting-verification', icon: 'fa-regular fa-clock', count: 0 },
      { title: 'Approved', color_class: 'text-info', type: 'approved', icon: 'fa-solid fa-thumbs-up', count: 0 },
      { title: 'Closed', color_class: 'text-secondary', type: 'closed', icon: 'fa-solid fa-lock', count: 0 }
    ],
    table_headers: ['Lead ID', 'Name', 'Email', 'Phone', 'Date Created', 'Status', 'Actions'],
    leads_list: [],
    is_loading: false,
    dataTable: null,
    enquiry_status: '',
    lead_form: {
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
    },
    lead_form_error: "",
    enquiry_form: null,
    enquiry_form_questions: [],
    lead_form_dynamic: {},  
  }),
  computed: {
    filtered_leads() {
      return this.leads_list.filter(
        (lead) => lead.Status.toLowerCase() === this.selected_status
      );
    }
  },
  mounted() {
    this.enquiry_form_id = sessionStorage.getItem('enquiry_form_id');
    this.enquiry_status = this.$route.query.status || 'in-progress';
    this.get_all_leads();
    this.get_enquiry_form_questions();
  },
  watch: {
    "$route.query.status"() {
      this.enquiry_status = this.$route.query.status || 'New Lead';
      this.get_all_leads();
    },
    
  },
  methods: {
    init_data_table() {
      if (this.dataTable) {
        this.dataTable.destroy();
      }
      
      this.dataTable = $('#leads_table').DataTable({
        responsive: true,
        emptyTable: "No data available in table",
        language: {
          info: "", // Capitalized "Entries"
          lengthMenu: "_MENU_&nbsp;&nbsp;Entries per page" // Added non-breaking space
        }
      });
    },

    reset_lead_form() {
      this.lead_form_error = "";

      const model = {};
      this.enquiry_form_questions.forEach((question_wrap) => {
        const question_type = question_wrap.question?.question_type;
        if (question_type === "multi_select") model[question_wrap.id] = [];
        else model[question_wrap.id] = "";
      });
      this.lead_form_dynamic = model;
    },


    get_enquiry_form_questions() {
      axios
        .get(GET_ENQUIRY_FORM_QUESTIONS, {
          params: { project_id: this.project_id },
          headers: this.headers,
        })
        .then((response) => {
          if (response.data?.status === "success") {
            this.enquiry_form = response.data.data;

            this.enquiry_form_questions = (this.enquiry_form.questions || [])
              .slice()
              .sort((a, b) => (a.display_order ?? 0) - (b.display_order ?? 0));

            const model = {};
            this.enquiry_form_questions.forEach((question_wrap) => {
              const question_type = question_wrap.question?.question_type;
              if (question_type === "multi_select") model[question_wrap.id] = [];
              else model[question_wrap.id] = "";
            });
            this.lead_form_dynamic = model;
          } else {
            this.show_error("Failed to load enquiry form questions");
          }
        })
        .catch((error) => {
          this.show_error(
            `Error fetching enquiry form questions: ${error.response?.data?.message}`
          );
        });
    },



    create_lead() {
      this.lead_form_error = "";

      if (!this.enquiry_form?.id) {
      this.lead_form_error = "Enquiry form not loaded.";
      return;
      }

      // Build responses
      const responses = this.enquiry_form_questions.map((question_wrap) => {
      const question_type = Reflect.get(question_wrap.question || {}, 'question_type');
      const value = Reflect.get(this.lead_form_dynamic, question_wrap.id);

      const answer =
        question_type === "multi_select"
        ? (Array.isArray(value) ? value.join(",") : "")
        : (value ?? "").toString().trim();

      return {
        enquiry_form_question_id: question_wrap.id,
        answer: answer,
      };
      });

      // Validate email
      if (!this.validate_email_field()) return;
      
      // Validate phone
      if (!this.validate_phone_field()) return;

      const payload = {
      enquiry_form_id: this.enquiry_form.id,
      responses: responses,
      };

      this.submit_lead(payload);
    },

    validate_email_field() {
      const email_wrap = this.enquiry_form_questions.find(qw =>
      Reflect.get(qw.question || {}, 'question_text')?.toLowerCase().includes("email")
      );
      if (email_wrap) {
      const email_val = Reflect.get(this.lead_form_dynamic, email_wrap.id)?.toString().trim() || "";
      if (!email_val || !validate_email(email_val)) {
        this.lead_form_error = email_val ? "Please enter a valid email address." : "Please enter an email address.";
        return false;
      }
      }
      return true;
    },

    validate_phone_field() {
      const phone_wrap = this.enquiry_form_questions.find(qw =>
      Reflect.get(qw.question || {}, 'question_text')?.toLowerCase().includes("phone")
      );
      if (phone_wrap) {
      const phone_val = Reflect.get(this.lead_form_dynamic, phone_wrap.id)?.toString().trim() || "";
      if (phone_val && !validate_phone_number(phone_val)) {
        this.lead_form_error = "Please enter a valid 10-digit phone number.";
        return false;
      }
      }
      return true;
    },

    submit_lead(payload) {
      this.is_loading = true;
      axios
      .post(SUBMIT_ENQUIRY_FORM, payload, { headers: this.headers })
      .then((response) => {
        if (response.data?.status === "success") {
        this.close_modal('add_lead_modal');
        this.reset_lead_form();
        this.get_all_leads();
        this.show_success(response.data?.message || "Lead added successfully.");
        } else {
        this.show_error(response.data?.message || "Failed to submit enquiry.");
        }
      })
      .catch((error) => {
        this.show_error(error.response?.data?.message || "Something went wrong while submitting.");
      })
      .finally(() => {
        this.is_loading = false;
      });
    },

    select_status(status) {
      this.selected_status = status;
    },

    process_leads_data(leads_data) {
      return leads_data.map(lead => {
        const questions = lead.questions;
        
        // Find each field by checking question_text 
        const first_name = Object.values(questions).find(q => 
          q.question_text?.toLowerCase().includes('first name'))?.answer || 'N/A';
        const last_name = Object.values(questions).find(q => 
          q.question_text?.toLowerCase().includes('last name'))?.answer || 'N/A';
        const email = Object.values(questions).find(q => 
          q.question_text?.toLowerCase().includes('email'))?.answer || 'N/A';
        const phone = Object.values(questions).find(q => 
          q.question_text?.toLowerCase().includes('phone'))?.answer || 'N/A';
        
        const submission_dates = Object.values(questions).map(question => new Date(question.submitted_at));
        const earliest_date = submission_dates.length ? new Date(Math.min(...submission_dates)) : null;
        
        return {
          id: lead.lead_id,
          'Lead ID': lead.lead_id,
          'Name': `${first_name} ${last_name}`.trim(),
          'Email': email,
          'Phone': phone,
          'Date Created': earliest_date ? this.format_date(earliest_date) : '',
          'Status': 'in-progress',
          questions: questions
        };
      });
    },

    update_status_counts() {
      this.status_cards = this.status_cards.map(card => (
        { ...card, count: this.leads_list.filter(lead => lead.Status === card.type).length }
      ));
    },
    
    

    get_all_leads() {
      this.is_loading = true;
      const params = {
        project_id: this.project_id,
        status: this.enquiry_status,

      };

      axios.get(GET_ENQUIRY_RESPONSES, { params: params, headers: this.headers })
        .then(response => {
          if (response.data.status === 'success') {
            this.leads_list = this.process_leads_data(response.data.data);
            this.update_status_counts();
          } else {
            this.show_error('Failed to load leads');
          }
        })
        .catch(error => {
          this.show_error(`Error fetching leads: ${error.response?.data?.message}`);
        })
        .finally(() => {
          this.is_loading = false;
        });
    }
  },
  beforeDestroy() {
    if (this.dataTable) {
      this.dataTable.destroy();
    }
  },
};

